import { useState } from "react";
export var useClickMenu = function () {
    var _a = useState(""), selectedUserId = _a[0], setSelectedUserId = _a[1];
    var handleClickMenu = function (e, options) {
        console.log("e", e);
        console.log("options", options);
        setSelectedUserId(e.id);
        switch (e.id) {
            case "1":
                console.log("modificar");
                break;
            case "2":
                console.log("eliminar");
                break;
            case "3":
                handleEnableDisableUser(options);
                break;
            case "4":
                console.log("ver roles");
                break;
            default:
                break;
        }
    };
    var handleEnableDisableUser = function (options) {
        console.log("options", options);
    };
    return {
        handleClickMenu: handleClickMenu,
        selectedUserId: selectedUserId
    };
};
